export default __webpack_public_path__ + "static/riders-frames-ef37b18d32d8081cf79b07f6d7f72478.gif";